<template>
  <div class="list_lmjp">
    <!-- <img class="list_lmjp_image list_lmjp_image_top" :src="hrefs + 'pic_60.png'" /> -->
    <!-- <img class="list_lmjp_image list_lmjp_image_top" src="../assets/pic_60.jpg" /> -->
    <div class="list_top"></div>
    <img class="list_lmjp_title list_lmjp_title_1" src="@/assets/pic_4.png" />
    <img class="list_lmjp_title list_lmjp_title_2" src="@/assets/pic_5.png" />
    <img class="list_lmjp_title list_lmjp_title_3" src="@/assets/pic_6.png" />
    <div v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="5" infinite-scroll-throttle-delay="1000">
      <ul class="list_lmjp_list">
        <li v-for="(item, index) in dataArray" :key="index" @click="onReturn(item)">
          <img class="img" :src="item.pic" />
          <p class="title">{{item.name}}</p>
          <div class="price">
            <p class="text_1">￥{{item.price}}</p>
            <!-- <p class="text_2">￥{{item.originalPrice}}</p> -->
          </div>
        </li>
      </ul>
    </div>
    <van-loading class="loading" v-if="loading" type="spinner" size="50px" color="#999" />
    <img class="list_lmjp_image list_lmjp_image_bottom" src="@/assets/pic_61.jpg" v-if="busy" />
  </div>
</template>
<script>
import infiniteScroll from 'vue-infinite-scroll'
import { activityList } from '@/request/api'
import { Loading } from 'vant'
export default {
  components: {
    [Loading.name]: Loading
  },
  directives: { infiniteScroll },
  name: 'active1',
  data() {
    return {
      busy: false,
      loading: false,
      activityId: '',
      images: '',
      dataArray: [],
      total: 1,
      pageSize: 12, // 每页数据
      pageNum: 1 // 分页
    }
  },
  created() {
    this.activityId = this.$route.query.id
    // this.loadMore()
  },
  methods: {
    // 回到小程序
    onReturn(item) {
      console.log(item)
      this.$router.push({ path: '/CommodityDetails', query: { id: item.id, skuId: item.defaultSkuId } })

      // this.$router.push(`/CommodityDetails/${id}`)
    },
    loadMore() {
      const _this = this
      // console.log(this.pageNum)
      // console.log(this.dataArray.length)
      // console.log(this.total)
      // console.log(this.dataArray.length >= this.total)
      this.busy = false
      this.loading = true
      const params = {
        activityId: _this.activityId,
        pageSize: _this.pageSize,
        pageNum: _this.pageNum
      }
      activityList(params).then(res => {
        console.log(res)
        if (res.code === 200) {
          if (res.data.list.length === 0) {
            this.loading = false
            this.busy = true
          } else {
            _this.pageNum = _this.pageNum + 1
            _this.total = res.data.total
            _this.loading = false
            _this.dataArray.concat(res.data.list)
            _this.dataArray = _this.dataArray.concat(res.data.list)
            _this.loading = false
          }
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style scoped>
.list_top{
    padding-top: 1000px;
}
.list_lmjp {
  /* min-height: 100vh; */
  background: url("../../assets/pic_60.jpg") no-repeat top center #f03166;
  background-size: contain;
  position: relative;
  /* z-index: -100; */
}
.list_lmjp_image {
  width: 750px;
}
.list_lmjp_image_bottom{
  height: 412px;
}
.list_lmjp_title {
  width: 750px;
  height: 180px;
  position: absolute;
  left: 0;
  z-index: 4;
}
.list_lmjp_title_1 {
  top: 1390px;
}
.list_lmjp_title_2 {
  top: 2740px;
}
.list_lmjp_title_3 {
  top: 4090px;
}
.list_lmjp_list {
  padding: 0 15px 15px;
  overflow: hidden;
  position: relative;
  z-index: 3;
}
.list_lmjp_list li {
  float: left;
  width: 230px;
  height: 370px;
  margin: 0 5px 10px;
  background-color: #fff;
  border-radius: 5px;
  overflow: hidden;
}
.list_lmjp_list li:nth-child(3),
.list_lmjp_list li:nth-child(12),
.list_lmjp_list li:nth-child(21) {
  margin-bottom: 220px;
}
.list_lmjp_list li .img {
  float: left;
  width: 230px;
  height: 230px;
}
.list_lmjp_list li .title {
  float: left;
  width: 100%;
  color: #333;
  font-size: 28px;
  line-height: 34px;
  height: 68px;
  padding: 0 10px;
  margin-top: 10px;
  /* 单行注释 */
  /* overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; */
  /* 多行注释 */
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  white-space: normal;
  -webkit-line-clamp: 2; /* 行数 */
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
}
.list_lmjp_list li .price {
  width: 100%;
  padding: 10px 10px 0;
  overflow: hidden;
}
.list_lmjp_list li .price .text_1,
.list_lmjp_list li .price .text_2 {
  float: left;
  margin-right: 16px;
}
.list_lmjp_list li .price .text_1 {
  color: #c8151d;
  font-size: 34px;
  font-weight: bold;
}
.list_lmjp_list li .price .text_2 {
  color: #999;
  font-size: 28px;
  padding-top: 0 4px;
  text-decoration: line-through;
}
.list_lmjp .loading {
  position: fixed;
  top: 50%;
  left: 50%;
  margin: -25px 0 0 -25px;
  z-index: 6;
}
</style>
